import { atom } from 'jotai'

/**
 * 積荷情報パネルに出す対象。
 * 親矢羽根なら束ね（DispatchGroup）配下の全明細、単独・子矢羽根ならその明細1本を表示する。
 */
export type SelectedCargoTarget =
  | { type: 'dispatchGroup'; dispatchGroupId: number }
  | { type: 'dispatchDetail'; dispatchDetailId: number }

/**
 * 積荷情報パネルの表示対象。
 *
 * 明細そのものではなく id を持ち、中身は配車板の rows から都度導出する。
 * 別車両への付け替え・配送依頼への戻しで rows が更新されたときに、パネルの表示を
 * そのまま追従させるため（未配車リスト側の selectedBundleId と同じ持ち方）。
 */
export const selectedCargoTargetAtom = atom<SelectedCargoTarget | null>(null)

selectedCargoTargetAtom.debugLabel = 'selectedCargoTargetAtom'
